import React, { ChangeEvent, FC } from 'react'
import { Modal } from '@root-gipro/shared/Modal/Modal'
import { TextareaAutosize, TextField } from '@material-ui/core'

interface ICommentModal {
	title?: string
	handler: () => void
	setAnchorEl(event: HTMLElement): void
	anchorEl: (EventTarget & HTMLElement) | null | undefined
	value: string
	onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
}

const CommentModal: FC<ICommentModal> = ({ anchorEl, handler, setAnchorEl, value, onChange }) => {
	const buttons = {
		PrimaryBtn: {
			handler: handler,
			value: 'Сохранить',
		},
		SecondaryBtn: {
			handler: () => setAnchorEl(null!),
			value: 'Отмена',
		},
	}

	const title = [
		{
			classes: 'leftTitle',
			value: 'Комментарий',
			action: undefined,
		},
	]

	return (
		<Modal buttonOptions={buttons} setAnchorEl={setAnchorEl} anchorEl={anchorEl} title={title} widthWindow='500px'>
			<TextareaAutosize
				value={value}
				onChange={onChange}
				placeholder='Введите комментарий'
				style={{
					width: 448,
					minHeight: 180,
					maxHeight: 300,
					padding: '16.5px 14px',
					fontSize: 14,
					fontFamily: 'inherit',
					border: '1px solid rgba(0, 0, 0, 0.23)',
					borderRadius: 4,
					resize: 'none',
					overflow: 'auto', 
					outline: 'none',
					boxSizing: 'border-box',
				}}
				onFocus={e => {
					e.currentTarget.style.border = '2px solid #1baaf0'
				}}
				onBlur={e => {
					e.currentTarget.style.border = '1px solid #1baaf0'
				}}
			/>
		</Modal>
	)
}

export default CommentModal
